// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-faq{display:flex}.component-faq--full .component-faq__pattern{display:none}.component-faq__pattern{display:flex;align-items:center;justify-content:flex-end;padding-right:5rem;width:25%;flex:0 0 25%}@media (min-width:768px) and (max-width:991.98px){.component-faq__pattern{width:auto;flex:0 0 auto;padding-right:2.5rem}}@media (max-width:767.98px){.component-faq__pattern{display:none}}.component-faq__list{flex:1 1 auto}", ""]);
// Exports
module.exports = exports;
